module.exports = __webpack_public_path__ + "img/logo_colorida.3d4f5f0a.png";